import { DivIcon } from 'leaflet/src/layer/marker/DivIcon';

export const littleDot = (strokeColor, fillColor) =>
  new DivIcon({
    html: `
    <svg>
      <circle cx="7" cy="7" r="6" stroke="${strokeColor}" stroke-width="2" fill="${fillColor}" />
    </svg>
    `,
    iconSize: [10, 10],
    popupAnchor: [0, -10],
    shadowSize: [0, 0],
    className: 'svg-div-icon-dot',
  });
